/**
 * Shopify Forms Custom Styles
 * Uses Shopify's official window.formStyles API to inject styles into shadow DOM
 */

(function () {
  'use strict';

  // Initialize formStyles Map if it doesn't exist
  window.formStyles = window.formStyles || new Map();

  // Define custom CSS rules
  const customStyles = `
    /* Teaser button (opens popup) */
    [class*="_teaserContainer_"] {
      background-color: #FF0E0E !important;
      color: #FFE001 !important;
      border: none !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      font-family: var(--font-heading-family), diatype_compressed_n4, sans-serif !important;
      font-size: 24px !important;
      font-weight: 700 !important;
      line-height: 0.85em !important;
      text-transform: uppercase !important;
      padding: 16px 32px !important;
      cursor: pointer !important;
      transition: opacity 0.2s ease !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      -webkit-appearance: none !important;
      appearance: none !important;
    }

    [class*="_teaserContainer_"]:hover {
      opacity: 0.9 !important;
      background-color: #FF0E0E !important;
    }

    [class*="_teaserContainer_"]:active {
      opacity: 0.8 !important;
    }

    [class*="_teaserHeading_"] {
      font-family: var(--font-heading-family), diatype_compressed_n4, sans-serif !important;
      font-size: 24px !important;
      font-weight: 700 !important;
      line-height: 0.85em !important;
      color: #FFE001 !important;
      text-transform: uppercase !important;
      margin: 0 !important;
    }

    /* Hide the X button inside teaser */
    [class*="_teaserContainer_"] [class*="_formCloseButton_"] {
      display: none !important;
    }

    /* Modal container */
    section[data-sizing="form-wrapper"] {
      background-color: rgba(0, 0, 0, 0.5) !important;
    }

    [class*="_formContainer_"] {
      background-color: #FFE001 !important;
      border-radius: 0 !important;
      max-width: 720px !important;
      width: clamp(320px, calc(320px + ((720 - 320) * ((100vw - 375px) / (1441 - 375)))), 720px) !important;
      max-height: 90vh !important;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3) !important;
      padding: 0 !important;
      border: none !important;
    }

    /* Grid layout */
    [class*="_grid_"] {
      display: flex !important;
      flex-direction: row !important;
      width: 100% !important;
      min-height: clamp(500px, calc(500px + ((600 - 500) * ((100vw - 375px) / (1441 - 375)))), 600px) !important;
    }

    /* Image container */
    [class*="_gridItem_"][style*="background-image"] {
      width: 50% !important;
      background-color: #FFE001 !important;
    }

    /* Content wrapper */
    [class*="_gridItemContent_"] {
      background-color: #FFE001 !important;
      padding: clamp(48px, calc(48px + ((64 - 48) * ((100vw - 375px) / (1441 - 375)))), 64px) clamp(24px, calc(24px + ((32 - 24) * ((100vw - 375px) / (1441 - 375)))), 32px) clamp(24px, calc(24px + ((32 - 24) * ((100vw - 375px) / (1441 - 375)))), 32px) !important;
      gap: clamp(16px, calc(16px + ((20 - 16) * ((100vw - 375px) / (1441 - 375)))), 20px) !important;
      width: 50% !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
    }

    /* Close button */
    [class*="_formContainerCloseButtonPosition_"] {
      top: 14.5px !important;
      right: 14.5px !important;
      z-index: 10 !important;
    }

    [class*="_formCloseButton_"] {
      width: 30px !important;
      height: 30px !important;
      background: none !important;
      color: #FF0E0E !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      cursor: pointer !important;
    }

    [class*="_formCloseButton_"]:hover {
      opacity: 0.7 !important;
    }

    [class*="_formCloseButton_"] svg {
      width: 15px !important;
      height: 15px !important;
    }

    [class*="_formCloseButton_"] svg path {
      fill: #FF0E0E !important;
      stroke: none !important;
    }

    /* Form header */
    [class*="_formHeader_"] {
      display: flex !important;
      flex-direction: column !important;
      gap: clamp(8px, calc(8px + ((12 - 8) * ((100vw - 375px) / (1441 - 375)))), 12px) !important;
      width: 100% !important;
      flex: none !important;
    }

    /* Heading */
    [class*="_textHeading_"] {
      font-family: diatype_compressed_n4, sans-serif !important;
      font-size: clamp(30px, calc(30px + ((38 - 30) * ((100vw - 375px) / (1441 - 375)))), 38px) !important;
      font-weight: 700 !important;
      line-height: 0.85em !important;
      color: #FF0E0E !important;
      text-transform: uppercase !important;
      text-align: center !important;
      margin: 0 !important;
      width: 100% !important;
    }

    /* Subheading */
    [class*="_textBody_"] {
      width: 100% !important;
    }

    [class*="_textBody_"] p {
      font-family: 'Work Sans', sans-serif !important;
      font-size: clamp(14px, calc(14px + ((16 - 14) * ((100vw - 375px) / (1441 - 375)))), 16px) !important;
      font-weight: 600 !important;
      line-height: 1.1em !important;
      letter-spacing: -0.04em !important;
      color: #FF0E0E !important;
      text-transform: uppercase !important;
      text-align: center !important;
      margin: 0 !important;
    }

    /* Form */
    [class*="_formFieldset_"] {
      gap: clamp(8px, calc(8px + ((10 - 8) * ((100vw - 375px) / (1441 - 375)))), 10px) !important;
      border: none !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      display: flex !important;
      flex-direction: column !important;
    }

    /* Field container */
    [class*="_formFieldContainer_"] {
      width: 100% !important;
      position: relative !important;
      display: block !important;
    }

    /* Inputs */
    [class*="_formInputField_"] {
      width: 100% !important;
      padding: clamp(12px, calc(12px + ((15 - 12) * ((100vw - 375px) / (1441 - 375)))), 15px) clamp(14px, calc(14px + ((16 - 14) * ((100vw - 375px) / (1441 - 375)))), 16px) !important;
      font-family: 'Work Sans', sans-serif !important;
      font-size: clamp(13px, calc(13px + ((14 - 13) * ((100vw - 375px) / (1441 - 375)))), 14px) !important;
      font-weight: 500 !important;
      line-height: 1em !important;
      letter-spacing: -0.04em !important;
      color: #FF0E0E !important;
      background-color: #FFE001 !important;
      border: 1.5px solid #FF0E0E !important;
      border-radius: 0 !important;
      text-align: left !important;
      text-transform: none !important;
      box-shadow: none !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      box-sizing: border-box !important;
    }

    /* Style floating labels to look like placeholders */
    [class*="_formInputFieldLabel_"] {
      font-family: 'Work Sans', sans-serif !important;
      font-size: clamp(13px, calc(13px + ((14 - 13) * ((100vw - 375px) / (1441 - 375)))), 14px) !important;
      font-weight: 500 !important;
      line-height: 1em !important;
      letter-spacing: -0.04em !important;
      color: #FF0E0E !important;
      opacity: 1 !important;
      text-transform: none !important;
      text-align: left !important;
      pointer-events: none !important;
      position: absolute !important;
      left: clamp(14px, calc(14px + ((16 - 14) * ((100vw - 375px) / (1441 - 375)))), 16px) !important;
      top: 50% !important;
      transform: translateY(-50%) !important;
      -webkit-transform: translateY(-50%) !important;
      transition: opacity 0.2s ease, visibility 0.2s ease !important;
      -webkit-transition: opacity 0.2s ease, visibility 0.2s ease !important;
      margin: 0 !important;
      visibility: visible !important;
      display: block !important;
      z-index: 1 !important;
    }

    /* Hide label only when input has value */
    [class*="_formInputFieldLabel_"].label-hidden {
      opacity: 0 !important;
      visibility: hidden !important;
    }

    [class*="_formInputField_"]::placeholder {
      color: transparent !important;
      text-align: left !important;
      text-transform: none !important;
    }

    [class*="_formInputField_"]:focus {
      border: 2px solid #FF0E0E !important;
      outline: none !important;
      box-shadow: none !important;
      padding: clamp(11px, calc(11px + ((14 - 11) * ((100vw - 375px) / (1441 - 375)))), 14px) clamp(13px, calc(13px + ((15 - 13) * ((100vw - 375px) / (1441 - 375)))), 15px) !important;
      text-align: left !important;
    }
    
    [class*="_formInputField_"]:focus::placeholder {
      color: #FF0E0E !important;
      opacity: 1 !important;
      text-align: left !important;
      text-transform: none !important;
    }

    /* Submit button */
    [class*="_formSubmitButton_"] {
      width: 100% !important;
      height: clamp(54px, calc(54px + ((62 - 54) * ((100vw - 375px) / (1441 - 375)))), 62px) !important;
      background-color: #FF0E0E !important;
      color: #FFE001 !important;
      border: none !important;
      font-family: diatype_compressed_n4, sans-serif !important;
      font-size: clamp(28px, calc(28px + ((32 - 28) * ((100vw - 375px) / (1441 - 375)))), 32px) !important;
      font-weight: 700 !important;
      line-height: 0.85em !important;
      text-transform: uppercase !important;
      cursor: pointer !important;
      text-align: center !important;
      border-radius: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      transition: opacity 0.2s ease !important;
    }

    [class*="_formSubmitButton_"]:hover {
      opacity: 0.9 !important;
    }

    [class*="_formSubmitButton_"]:active {
      opacity: 0.8 !important;
    }
    
    [class*="_formSubmitButton_"]:disabled {
      opacity: 0.6 !important;
      cursor: not-allowed !important;
    }

    /* Disclaimer */
    [class*="_formDisclaimer_"] {
      font-family: 'Work Sans', sans-serif !important;
      font-size: clamp(11px, calc(11px + ((12 - 11) * ((100vw - 375px) / (1441 - 375)))), 12px) !important;
      font-weight: 500 !important;
      line-height: 1.2em !important;
      letter-spacing: -0.04em !important;
      color: #FF0E0E !important;
      text-align: center !important;
      text-transform: none !important;
      width: 100% !important;
      margin-top: 4px !important;
    }

    [class*="_formDisclaimer_"] p {
      margin: 0 !important;
      font-family: 'Work Sans', sans-serif !important;
      font-size: clamp(11px, calc(11px + ((12 - 11) * ((100vw - 375px) / (1441 - 375)))), 12px) !important;
      line-height: 1.2em !important;
      color: #FF0E0E !important;
      text-transform: none !important;
    }

    [class*="_formDisclaimer_"] a {
      color: #FF0E0E !important;
      text-decoration: underline !important;
      transition: opacity 0.2s ease !important;
    }

    [class*="_formDisclaimer_"] a:hover {
      opacity: 0.7 !important;
    }

    /* Error/Success messages */
    [class*="_formError_"],
    [class*="_formSuccess_"] {
      margin-top: clamp(12px, calc(12px + ((16 - 12) * ((100vw - 375px) / (1441 - 375)))), 16px) !important;
      padding: clamp(10px, calc(10px + ((12 - 10) * ((100vw - 375px) / (1441 - 375)))), 12px) clamp(14px, calc(14px + ((16 - 14) * ((100vw - 375px) / (1441 - 375)))), 16px) !important;
      font-family: 'Work Sans', sans-serif !important;
      font-size: clamp(13px, calc(13px + ((14 - 13) * ((100vw - 375px) / (1441 - 375)))), 14px) !important;
      font-weight: 500 !important;
      border-radius: 0 !important;
      text-align: center !important;
      background-color: rgba(255, 14, 14, 0.1) !important;
      color: #FF0E0E !important;
      border: 1px solid #FF0E0E !important;
    }

    /* Success message - full width styling */
    [class*="_formSuccess_"] {
      width: 100% !important;
      padding: clamp(32px, calc(32px + ((48 - 32) * ((100vw - 375px) / (1441 - 375)))), 48px) clamp(24px, calc(24px + ((32 - 24) * ((100vw - 375px) / (1441 - 375)))), 32px) !important;
      margin: 0 !important;
      font-family: var(--font-heading-family), diatype_compressed_n4, sans-serif !important;
      font-size: clamp(24px, calc(24px + ((32 - 24) * ((100vw - 375px) / (1441 - 375)))), 32px) !important;
      font-weight: 700 !important;
      line-height: 1.1em !important;
      text-transform: uppercase !important;
      background-color: transparent !important;
      border: none !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      align-items: center !important;
      gap: clamp(16px, calc(16px + ((24 - 16) * ((100vw - 375px) / (1441 - 375)))), 24px) !important;
      min-height: 200px !important;
    }

    /* Hide form when success message is shown */
    [class*="_formSuccess_"] ~ [class*="_formFieldset_"],
    [class*="_formSuccess_"] ~ * [class*="_formFieldset_"] {
      display: none !important;
    }

    /* Mobile responsive */
    @media screen and (max-width: 749px) {
      [class*="_formContainer_"] {
        max-width: 480px !important;
        width: 95vw !important;
        overflow: hidden !important;
      }
      
      [class*="_grid_"] {
        flex-direction: column !important;
        min-height: auto !important;
      }
      
      [class*="_gridItem_"][style*="background-image"] {
        width: 100% !important;
        min-height: 200px !important;
        height: auto !important;
        aspect-ratio: 1 / 1 !important;
        max-height: 300px !important;
        background-position-x: center !important;
        background-position-y: 75% !important;
      }
      
      [class*="_gridItemContent_"] {
        width: 100% !important;
        padding: 24px 16px 20px !important;
        gap: 12px !important;
        box-sizing: border-box !important;
      }
      
      [class*="_textHeading_"] {
        font-size: 22px !important;
        line-height: 0.85em !important;
      }
      
      [class*="_textBody_"] p {
        font-size: 12px !important;
      }
      
      [class*="_formFieldset_"] {
        gap: 8px !important;
        width: 100% !important;
        box-sizing: border-box !important;
      }
      
      [class*="_formFieldContainer_"] {
        width: 100% !important;
        box-sizing: border-box !important;
      }
      
      [class*="_formInputField_"] {
        width: 100% !important;
        font-size: 13px !important;
        padding: 12px 14px !important;
        box-sizing: border-box !important;
      }
      
      [class*="_formInputField_"]:focus {
        padding: 11px 13px !important;
      }
      
      [class*="_formInputFieldLabel_"] {
        font-size: 13px !important;
        left: 14px !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        -webkit-transform: translateY(-50%) !important;
        opacity: 1 !important;
        visibility: visible !important;
        position: absolute !important;
        pointer-events: none !important;
        z-index: 10 !important;
        display: block !important;
        color: #FF0E0E !important;
        font-family: 'Work Sans', sans-serif !important;
        font-weight: 500 !important;
        line-height: 1em !important;
        letter-spacing: -0.04em !important;
        text-align: left !important;
        text-transform: none !important;
        margin: 0 !important;
        transition: opacity 0.2s ease, visibility 0.2s ease !important;
        -webkit-transition: opacity 0.2s ease, visibility 0.2s ease !important;
      }
      
      /* Hide label only when input has value on mobile */
      [class*="_formInputFieldLabel_"].label-hidden {
        opacity: 0 !important;
        visibility: hidden !important;
      }
      
      [class*="_formSubmitButton_"] {
        width: 100% !important;
        height: 48px !important;
        font-size: 24px !important;
        box-sizing: border-box !important;
      }
      
      [class*="_formDisclaimer_"] {
        font-size: 10px !important;
        line-height: 1.3em !important;
        width: 100% !important;
        box-sizing: border-box !important;
      }
      
      /* Success message on mobile */
      [class*="_formSuccess_"] {
        font-size: 20px !important;
        padding: 24px 16px !important;
        min-height: 150px !important;
        line-height: 1.2em !important;
      }
      
      /* Close button on mobile */
      [class*="_formContainerCloseButtonPosition_"] {
        top: 10px !important;
        right: 10px !important;
      }
      
      [class*="_formCloseButton_"] svg {
        width: 16px !important;
        height: 16px !important;
      }
    }

    @media screen and (min-width: 1442px) {
      [class*="_formContainer_"] {
        width: 720px !important;
      }
    }
  `;

  const linktreeStyles = `
    /* Container: transparent, no chrome */
    [class*="_formContainer_"],
    [class*="_inline_"] {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
      margin: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
      border-radius: 0 !important;
      overflow: visible !important;
    }

    section[data-sizing="form-wrapper"] {
      background-color: transparent !important;
    }

    [class*="_grid_"] {
      flex-direction: column !important;
      min-height: auto !important;
      width: 100% !important;
    }

    [class*="_gridItem_"][class*="_imageLoading_"],
    [class*="_gridItem_"][style*="background-image"] {
      display: none !important;
    }

    [class*="_gridItemContent_"] {
      width: 100% !important;
      padding: 0 !important;
      gap: 6px !important;
      background-color: transparent !important;
    }

    [class*="_formContainerCloseButtonPosition_"],
    [class*="_formCloseButton_"] {
      display: none !important;
    }

    /* Header: hide title since the section provides it */
    [class*="_formHeader_"] {
      gap: 2px !important;
    }

    [class*="_formHeader_"] [class*="_textHeading_"] {
      display: none !important;
    }

    [class*="_textBody_"],
    [class*="_textBody_"] p {
      font-family: 'Work Sans', sans-serif !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      line-height: 1.3em !important;
      letter-spacing: -0.02em !important;
      color: #FF0E0E !important;
      text-transform: uppercase !important;
      text-align: center !important;
      margin: 0 0 4px !important;
    }

    [class*="_formHeader_"] {
      margin-bottom: 4px !important;
      gap: 2px !important;
    }

    /* Fieldset */
    [class*="_formFieldset_"] {
      gap: 0 !important;
      border: none !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }

    /* Field containers */
    [class*="_formFieldContainer_"] {
      width: 100% !important;
      display: flex !important;
      flex-direction: column !important;
      margin-bottom: 8px !important;
    }

    /* Labels: static, always above input */
    [class*="_formInputFieldLabel_"] {
      font-family: 'Work Sans', sans-serif !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      letter-spacing: 0.06em !important;
      line-height: 1em !important;
      text-transform: uppercase !important;
      color: #FF0E0E !important;
      opacity: 1 !important;
      position: static !important;
      transform: none !important;
      -webkit-transform: none !important;
      visibility: visible !important;
      display: block !important;
      order: -1 !important;
      pointer-events: auto !important;
      margin: 0 0 4px !important;
      padding: 0 !important;
      top: auto !important;
      left: auto !important;
      z-index: auto !important;
      transition: none !important;
    }

    [class*="_formInputFieldLabel_"][class*="_inputFilled_"],
    [class*="_formInputFieldLabel_"].label-hidden {
      position: static !important;
      transform: none !important;
      -webkit-transform: none !important;
      opacity: 1 !important;
      visibility: visible !important;
      font-size: 11px !important;
      top: auto !important;
    }

    /* Inputs */
    [class*="_formInputField_"] {
      width: 100% !important;
      padding: 12px 14px !important;
      font-family: 'Work Sans', sans-serif !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 1em !important;
      letter-spacing: -0.02em !important;
      color: #FF0E0E !important;
      background-color: #FFE001 !important;
      border: 1.5px solid #FF0E0E !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      box-sizing: border-box !important;
      min-height: 44px !important;
    }

    [class*="_formInputField_"]::placeholder {
      color: rgba(255, 14, 14, 0.3) !important;
    }

    [class*="_formInputField_"]:focus {
      border: 2px solid #FF0E0E !important;
      outline: none !important;
      box-shadow: none !important;
      padding: 11px 13px !important;
    }

    /* Phone field */
    [class*="_formPhoneInputContainer_"] {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: flex-end !important;
      gap: 6px !important;
      width: 100% !important;
      margin-bottom: 8px !important;
    }

    .phone-country-selector {
      flex-shrink: 0 !important;
      width: auto !important;
    }

    [class*="_selectContainer_"] {
      position: static !important;
    }

    [class*="_selectToggle_"] {
      display: flex !important;
      align-items: center !important;
      gap: 4px !important;
      padding: 10px 8px !important;
      min-height: 44px !important;
      background-color: #FFE001 !important;
      border: 1.5px solid #FF0E0E !important;
      border-radius: 0 !important;
      box-sizing: border-box !important;
      cursor: pointer !important;
      position: static !important;
    }

    [class*="_selectToggle_"]:focus {
      border: 2px solid #FF0E0E !important;
      padding: 9px 7px !important;
    }

    [class*="_flagIcon_"] {
      width: 24px !important;
      height: 18px !important;
    }

    [class*="_arrowDownIcon_"] svg path {
      fill: #FF0E0E !important;
    }

    [class*="_formPhoneInputContainer_"] > [class*="_formFieldContainer_"] {
      flex: 1 !important;
      min-width: 0 !important;
      margin-bottom: 0 !important;
    }

    [class*="_formPhoneInputField_"] {
      width: 100% !important;
      padding: 12px 14px !important;
      font-family: 'Work Sans', sans-serif !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 1em !important;
      color: #FF0E0E !important;
      background-color: #FFE001 !important;
      border: 1.5px solid #FF0E0E !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      box-sizing: border-box !important;
      min-height: 44px !important;
    }

    [class*="_formPhoneInputField_"]:focus {
      border: 2px solid #FF0E0E !important;
      outline: none !important;
      box-shadow: none !important;
      padding: 11px 13px !important;
    }

    [class*="_formPhoneInputContainer_"] {
      position: relative !important;
      margin-top: 18px !important;
    }

    [class*="_formPhoneInputContainer_"] [class*="_formInputFieldLabel_"],
    [class*="_formPhoneInputContainer_"] [class*="_formInputFieldLabel_"][class*="_inputFilled_"] {
      position: absolute !important;
      top: -18px !important;
      left: 0 !important;
      transform: none !important;
      -webkit-transform: none !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      font-size: 11px !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;
      width: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      text-align: left !important;
      order: unset !important;
      line-height: 1em !important;
    }

    [class*="_formPhoneInputContainer_"] > [class*="_formFieldContainer_"] {
      margin-bottom: 0 !important;
    }

    /* Country selector dropdown */
    [class*="_selectContainer_"],
    .phone-country-selector,
    [class*="_formPhoneInputContainer_"] {
      overflow: visible !important;
    }

    [class*="_dropdownContainer_"] {
      max-height: 50vh !important;
    }

    [class*="_optionList_"] {
      max-height: 50vh !important;
    }

    /* Submit -- secondary style */
    [class*="_formSubmitButton_"] {
      width: 100% !important;
      height: clamp(44px, 5dvh, 52px) !important;
      background-color: transparent !important;
      color: #FF0E0E !important;
      border: 1.5px solid #FF0E0E !important;
      font-family: diatype_compressed_n4, sans-serif !important;
      font-size: clamp(18px, 2.5dvh, 24px) !important;
      font-weight: 700 !important;
      line-height: 0.85em !important;
      text-transform: uppercase !important;
      cursor: pointer !important;
      text-align: center !important;
      border-radius: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      -webkit-appearance: none !important;
      appearance: none !important;
    }

    [class*="_formSubmitButton_"]:hover {
      background-color: #FF0E0E !important;
      color: #FFE001 !important;
    }

    [class*="_formSubmitButton_"]:disabled {
      opacity: 0.6 !important;
      cursor: not-allowed !important;
    }

    /* Disclaimer */
    [class*="_formDisclaimer_"],
    [class*="_formDisclaimer_"] p {
      font-family: 'Work Sans', sans-serif !important;
      font-size: 8px !important;
      font-weight: 500 !important;
      line-height: 1.2em !important;
      color: #FF0E0E !important;
      text-align: center !important;
      margin: -4px 0 0 !important;
      padding: 0 !important;
    }

    [class*="_formDisclaimer_"] a {
      color: #FF0E0E !important;
      text-decoration: underline !important;
    }

    /* Success: fill remaining space with green */
    [data-current-step="success"] {
      flex: 1 !important;
      display: flex !important;
      flex-direction: column !important;
    }

    [data-current-step="success"] [class*="_container_"],
    [data-current-step="success"] [class*="_inline_"],
    [data-current-step="success"] [class*="_formContainer_"],
    [data-current-step="success"] [class*="_gridItem_"],
    [data-current-step="success"] [class*="_gridItemContent_"] {
      flex: 1 !important;
      display: flex !important;
      flex-direction: column !important;
    }

    [class*="_formBannerContainer_"],
    [class*="_formSuccess_"] {
      width: 100% !important;
      flex: 1 !important;
      padding: 32px 20px !important;
      margin: 0 !important;
      background-color: var(--Verde, #006629) !important;
      border: 2px solid #004d1f !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
      min-height: 200px !important;
    }

    [class*="_formBannerHeading_"],
    [class*="_formSuccess_"] [class*="_textHeading_"],
    [class*="_formSuccess_"] h2,
    [class*="_formBannerContainer_"] h2 {
      font-family: diatype_compressed_n4, sans-serif !important;
      font-size: clamp(24px, 4dvh, 36px) !important;
      font-weight: 700 !important;
      line-height: 0.9em !important;
      text-transform: uppercase !important;
      text-align: center !important;
      color: #FFFFFF !important;
      margin: 0 0 12px !important;
    }

    [class*="_formBannerContainer_"] [class*="_textBody_"],
    [class*="_formBannerContainer_"] [class*="_textBody_"] p,
    [class*="_formBannerContainer_"] p,
    [class*="_formSuccess_"] [class*="_textBody_"],
    [class*="_formSuccess_"] [class*="_textBody_"] p,
    [class*="_formSuccess_"] p {
      font-family: 'Work Sans', sans-serif !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 1.3em !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
      text-align: center !important;
      color: rgba(255, 255, 255, 0.85) !important;
      margin: 0 !important;
    }

    [class*="_formError_"],
    [class*="_fieldError_"],
    [class*="_errorMessage_"],
    [class*="_formFieldContainer_"] > div:last-child:not([class*="_formInputField_"]):not([class*="_formFieldContainer_"]) {
      display: block !important;
      background-color: #CC0000 !important;
      color: #FFFFFF !important;
      border: none !important;
      border-radius: 0 !important;
      font-family: 'Work Sans', sans-serif !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      text-align: center !important;
      padding: 6px 10px !important;
      margin: 2px 0 0 !important;
      letter-spacing: 0.02em !important;
      line-height: 1.2em !important;
      box-shadow: none !important;
      position: static !important;
      width: 100% !important;
      box-sizing: border-box !important;
      order: 10 !important;
    }

    [class*="_formInputField_"][aria-invalid="true"] {
      border: 2px solid #CC0000 !important;
      padding: 11px 13px !important;
    }

    [class*="_formPhoneInputContainer_"] [class*="_error_"],
    [class*="_formPhoneInputContainer_"] [class*="_errorMessage_"],
    [class*="_formPhoneInputContainer_"] [class*="_fieldError_"],
    [class*="_formPhoneInputContainer_"] > [class*="_formFieldContainer_"] > div:last-child:not([class*="_formInputField_"]) {
      flex-basis: 100% !important;
      order: 10 !important;
      width: 100% !important;
      margin: 2px 0 0 !important;
    }

    [class*="_formPhoneInputContainer_"] [class*="_formInputFieldLabel_"] ~ div:not([class*="_formInputField_"]) {
      position: static !important;
      flex-basis: 100% !important;
      order: 10 !important;
    }
  `;

  window.formStyles.set('jaleo-custom-newsletter', customStyles);

  function checkLinktree() {
    if (document.documentElement.classList.contains('lt-page')) {
      window.formStyles.set('jaleo-linktree', linktreeStyles);
    }
  }

  checkLinktree();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkLinktree);
  }

  function setupLabelBehavior() {
    if (document.documentElement.classList.contains('lt-page')) return true;

    let setupDone = false;
    
    document.querySelectorAll('*').forEach(element => {
      if (element.shadowRoot) {
        const containers = element.shadowRoot.querySelectorAll('[class*="_formFieldContainer_"]');
        
        containers.forEach(container => {
          const input = container.querySelector('[class*="_formInputField_"]');
          const label = container.querySelector('[class*="_formInputFieldLabel_"]');
          
          if (input && label && !input.hasAttribute('data-label-setup')) {
            input.setAttribute('data-label-setup', 'true');
            
            const toggleLabel = () => {
              if (input.value && input.value.trim().length > 0) {
                label.classList.add('label-hidden');
              } else {
                label.classList.remove('label-hidden');
              }
            };
            
            input.addEventListener('input', toggleLabel);
            input.addEventListener('blur', toggleLabel);
            input.addEventListener('change', toggleLabel);
            
            toggleLabel();
            setupDone = true;
          }
        });
      }
    });
    
    return setupDone;
  }

  const requiredFields = ['first_name', 'email', 'phone_number'];

  function markRequiredLabels() {
    document.querySelectorAll('*').forEach(element => {
      if (element.shadowRoot) {
        requiredFields.forEach(fieldId => {
          const input = element.shadowRoot.querySelector('#' + fieldId);
          if (!input) return;
          const container = input.closest('[class*="_formFieldContainer_"]') || input.closest('[class*="_formPhoneInputContainer_"]');
          if (!container) return;
          const label = container.querySelector('[class*="_formInputFieldLabel_"]');
          if (label && !label.hasAttribute('data-required-marked')) {
            label.setAttribute('data-required-marked', 'true');
            label.textContent = label.textContent.trim() + ' *';
          }
        });
      }
    });
  }

  function fixAutocomplete() {
    document.querySelectorAll('*').forEach(element => {
      if (element.shadowRoot) {
        element.shadowRoot.querySelectorAll('input[autocomplete="off"], input:not([autocomplete])').forEach(input => {
          if (input.hasAttribute('data-ac-fixed')) return;
          input.setAttribute('data-ac-fixed', 'true');
          const id = (input.id || '').toLowerCase();
          const type = input.type || '';
          if (id.includes('first_name') || id.includes('name')) {
            input.setAttribute('autocomplete', 'name');
            input.setAttribute('name', 'name');
          } else if (id.includes('email') || type === 'email') {
            input.setAttribute('autocomplete', 'email');
            input.setAttribute('type', 'email');
            input.setAttribute('name', 'email');
          } else if (id.includes('empresa') || id.includes('company')) {
            input.setAttribute('autocomplete', 'organization');
            input.setAttribute('name', 'organization');
          } else if (type === 'tel' || id.includes('phone')) {
            input.setAttribute('autocomplete', 'tel');
            input.setAttribute('name', 'phone');
          }
        });
      }
    });
  }

  function initLabelWatcher() {
    const formObserver = new MutationObserver(() => {
      setTimeout(() => { setupLabelBehavior(); fixAutocomplete(); markRequiredLabels(); }, 100);
    });

    if (document.body) {
      formObserver.observe(document.body, { childList: true, subtree: true });
    }

    let checkCount = 0;
    const pollInterval = setInterval(() => {
      fixAutocomplete();
      markRequiredLabels();
      if (setupLabelBehavior() && ++checkCount > 5) {
        clearInterval(pollInterval);
      }
      if (checkCount >= 100) clearInterval(pollInterval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLabelWatcher);
  } else {
    initLabelWatcher();
  }
})();
